import React from 'react';
import { IoArrowBackOutline, IoArrowForwardOutline } from 'react-icons/io5';
import BotHeaderTooltip from '../bot-core/BotHeaderTooltip';
import type { BotDockSide } from './hooks/useBotDockSide';

interface Props {
  side: BotDockSide;
  onToggle: () => void;
  moveToLeftLabel: string;
  moveToRightLabel: string;
}

const BotDockSideButton: React.FC<Props> = ({
  side,
  onToggle,
  moveToLeftLabel,
  moveToRightLabel,
}) => {
  const movingLeft = side === 'right';
  const label = movingLeft ? moveToLeftLabel : moveToRightLabel;
  return (
    <BotHeaderTooltip title={label}>
      <button
        className="bot-icon-btn bot-dock-side-btn"
        aria-label={label}
        onClick={onToggle}
      >
        {movingLeft ? <IoArrowBackOutline size={20} /> : <IoArrowForwardOutline size={20} />}
      </button>
    </BotHeaderTooltip>
  );
};

export default BotDockSideButton;
